var map = {
	"./ArticleLayout": 9951,
	"./AuthLayout": 6905,
	"./CabinetLayout": 6633,
	"./DefaultLayout": 6710,
	"./ErrorLayout": 1864,
	"./SoonLayout": 3612
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1162;